import { OptionTile } from "@manifesthhqinc/ui-library";
import { TitleLarge } from "../../../components/font";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Container from "../../../layout/container";
import ScrollableContainer from "../../../layout/scrollable-container";
import { OptionTileContainer } from "./styles";
import { RetirementHorizon, UseHenryQuestionniareProps } from "../useHenryQuestionnaire";
import HeadingContainer from "../../../layout/heading-container";

const HenryQuestionnaireOne = (props: UseHenryQuestionniareProps) => {
  const { updateHenryQuestionnaire } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="henry-questionnaire-form-1">
        <Container>
          <HeadingContainer paneVariant="optionForm" withProgressBar>
            <TitleLarge>Roughly how far away do you think your retirement is?</TitleLarge>
          </HeadingContainer>
          <OptionTileContainer>
            <OptionTile
              name="20+ years from now"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ retirementHorizon: RetirementHorizon.MORE_THAN_20_YEARS })}
            >
              20+ years from now
            </OptionTile>
            <OptionTile
              name="20+ years from now"
              variant="clickthrough"
              appearance="secondary"
              onClick={() => updateHenryQuestionnaire({ retirementHorizon: RetirementHorizon.BETWEEN_10_AND_20_YEARS })}
            >
              10–20 years from now
            </OptionTile>
            <OptionTile
              name="20+ years from now"
              variant="clickthrough"
              appearance="secondary"
              onClick={() =>
                updateHenryQuestionnaire({ retirementHorizon: RetirementHorizon.LESS_THAN_OR_EQUAL_10_YEARS })
              }
            >
              Less than 10 years away
            </OptionTile>
          </OptionTileContainer>
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};
export default HenryQuestionnaireOne;
